import React, { useState } from 'react';
import './CalculatorPage.css';

function PartnershipCompatibilityTool() {
  const [name1, setName1] = useState('');
  const [name2, setName2] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculateNameValue = (name) => {
    let sum = 0;
    const nameMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < name.length; i++) {
      const char = name[i].toUpperCase();
      if (nameMap[char]) {
        sum += nameMap[char];
      }
    }
    return sum;
  };

  const calculateCompatibility = (n1, n2) => {
    // Placeholder for Partnership Compatibility calculation logic
    // This is a simplified example; real compatibility would be more complex.
    if (!n1 || !n2) return null;

    const value1 = calculateNameValue(n1);
    const value2 = calculateNameValue(n2);

    // Simple compatibility based on sum of values
    const compatibilityScore = (value1 + value2) % 9 || 9;

    return compatibilityScore;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!name1 || !name2) {
      setError('Please enter both names.');
      return;
    }

    const calculated = calculateCompatibility(name1, name2);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (score) => {
    return `Compatibility Score ${score}: This is a placeholder explanation for partnership compatibility score ${score}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Partnership Compatibility Tool",
    "description": "Check the numerological compatibility between two individuals for business or personal partnerships.",
    "url": "https://www.yourwebsite.com/partnership-compatibility-tool",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Partnership Compatibility",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/partnership-compatibility-tool?name1={name1}&name2={name2}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=name1",
        "required name=name2"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Partnership Compatibility Tool</h1>
      <p className="text-center">Enter two names to check their numerological compatibility for partnerships.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="name1">Name 1:</label>
          <input
            type="text"
            id="name1"
            className="form-control"
            value={name1}
            onChange={(e) => setName1(e.target.value)}
            placeholder="e.g., John"
          />
        </div>
        <div className="form-group">
          <label htmlFor="name2">Name 2:</label>
          <input
            type="text"
            id="name2"
            className="form-control"
            value={name2}
            onChange={(e) => setName2(e.target.value)}
            placeholder="e.g., Jane"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Check Compatibility</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Compatibility Score: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default PartnershipCompatibilityTool;
